import React from "react";
import { ProgramParticipantScoringStatus } from "../../../../../../../services/types/scoringStatusTypes";
import RaterStatusCell, { RaterStatusCellProps } from "../raterStatusCell";
import BaseLegendTable from "./baseLegendTable";
import { SelfStatusCellProps } from "../selfStatusCell";
import { ScoringStatusCellProps } from "../scoreStatusCell";

interface RaterLegendTableProps {}

const RaterLegendTable: React.FC<RaterLegendTableProps> = () => {
    const generateParticipantData = (
        minRequired: number,
        invited: number,
        completed: number,
        recievedLate: number
    ): ProgramParticipantScoringStatus => {
        return {
            individualId: 0,
            participantId: 0,
            firstName: "",
            lastName: "",
            email: "",
            language: "",
            additionalInstruments: [],
            instruments: [
                {
                    instrumentType: 0,
                    selfAssessmentStatusTypeId: 1,
                    formActualKey: -1,
                    forms: [
                        {
                            formMasterId: 0,
                            language: "",
                            raterTypeId: 1,
                            raterTypeName: "",
                            minimumRequired: minRequired,
                            minimumRecommended: 0,
                            surveysSent: invited,
                            receivedCount: completed,
                            receivedLateCount: recievedLate,
                            formActualErrors: 0,
                        },
                    ],
                    supportedRaterTypeCount: 0,
                    instrumentId: 1,
                    shortName: "",
                    name: "",
                    selfAssessmentStatusTypeName: "",
                    scoringStatus: 0,
                    scoringStatusDateTime: new Date(),
                    reportId: "",
                    assetInfoId: 0,
                    versionI: "",
                    scorable: false,
                    reportQuality: 0,
                    reportQualityTypeId: 0,
                    reportQualityTypeName: "",
                },
            ],
        };
    };

    const data: { cellData: RaterStatusCellProps; comment: string }[] = [
        {
            cellData: {
                participant: generateParticipantData(0, 0, 0, 0),
                instrumentId: 1,
                raterId: 1,
                isWide: false,
            },
            comment: "Assessment has been deactivated or cancelled",
        },
        {
            cellData: {
                participant: generateParticipantData(0, 0, 0, 0),
                instrumentId: 1,
                raterId: 1,
                isWide: false,
            },
            comment: "No Raters assigned for category with no minimum required responses",
        },
        {
            cellData: {
                participant: generateParticipantData(0, 2, 0, 0),
                instrumentId: 1,
                raterId: 1,
                isWide: false,
            },
            comment: "0 of 2 responses received for category with no minimum requirements",
        },
        {
            cellData: {
                participant: generateParticipantData(5, 2, 2, 0),
                instrumentId: 1,
                raterId: 1,
                isWide: false,
            },
            comment: "Minimum responses not received and minimum raters not assigned",
        },
        {
            cellData: {
                participant: generateParticipantData(5, 5, 2, 0),
                instrumentId: 1,
                raterId: 1,
                isWide: false,
            },
            comment: "Minimum responses not received",
        },
        {
            cellData: {
                participant: generateParticipantData(3, 5, 3, 0),
                instrumentId: 1,
                raterId: 1,
                isWide: false,
            },
            comment: "Minimum responses received",
        },
        {
            cellData: {
                participant: generateParticipantData(3, 5, 5, 0),
                instrumentId: 1,
                raterId: 1,
                isWide: false,
            },
            comment: "All responses received",
        },
        {
            cellData: {
                participant: generateParticipantData(3, 5, 5, 1),
                instrumentId: 1,
                raterId: 1,
                isWide: false,
            },
            comment: "All responses received with 1 late response not included in scored report",
        },
    ];

    return (
        <BaseLegendTable
            statusCellType={
                RaterStatusCell as React.ElementType<
                    SelfStatusCellProps | RaterStatusCellProps | ScoringStatusCellProps
                >
            }
            data={data}
            title="360 Rater Categories"
        />
    );
};

export default RaterLegendTable;
